const nightColors = {
  darkBlue: '#0D1B32',
  navyMed: '#1C2F4E',
  white: '#FFFFFF',
  darkGrey: '#676A70',
  blue: '#1652F0'
};
const nightTheme = {
  color: {
    background: nightColors.darkBlue,
    border: nightColors.navyMed,
    text: nightColors.white,
    textAccent: nightColors.blue,
    textLight: nightColors.darkGrey,
    backgroundAlt: nightColors.navyMed
  },
  logoKey: 'white'
};
export { nightTheme as default };
//# sourceMappingURL=nightTheme.js.map
